import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilePreviewService {
  /**
   * Creates a preview URL for an image file
   * @param file - The File object to create preview for
   * @returns The preview URL if the file is an image, undefined otherwise
   */
  createPreviewUrl(file: File): string | undefined {
    if (!file.type?.startsWith('image/')) {
      return undefined;
    }
    return URL.createObjectURL(file);
  }

  /**
   * Revokes a preview URL to free up memory
   * @param url - The preview URL to revoke
   */
  revokePreviewUrl(url?: string): void {
    if (url) {
      URL.revokeObjectURL(url);
    }
  }

  /**
   * Revokes multiple preview URLs
   * @param urls - Array of preview URLs to revoke
   */
  revokePreviewUrls(urls: (string | undefined)[]): void {
    urls.forEach((url) => this.revokePreviewUrl(url));
  }
}

